import { Breakpoint, useTheme } from 'styled-components';
import { isString } from 'lodash-es';
import { useMedia } from 'react-use';

export const useUpMedia = (breakpoint: Breakpoint | number) => {
  const theme = useTheme();
  return useMedia(
    `(min-width: ${isString(breakpoint) ? theme.breakpoints[breakpoint] : breakpoint}px)`
  );
};
